<script setup>
import { RouterLink, useRouter } from "vue-router";
import { computed } from "vue";
import Menu from "./components/Menu.vue";

const router = useRouter();

const isVastgoed = computed(() =>
  router.currentRoute.value.path.includes("vastgoed")
);
const isStichting = computed(() =>
  router.currentRoute.value.path.includes("stichting")
);
</script>
<template>
  <div class="app-container relative">
    <header class="navigation" v-if="isVastgoed">
      <img class="h-14 sm:h-20" src="./assets/logo.png" />
      <RouterLink to="/">
        <Menu class="h-12 text-blue-300" />
      </RouterLink>
    </header>
    <header class="navigation" v-else-if="isStichting">
      <img class="h-14 sm:h-20" src="./assets/stichting-logo.png" />
      <RouterLink to="/">
        <Menu class="h-12 text-green-300" />
      </RouterLink>
    </header>
    <RouterView />
    <footer v-if="isStichting" class="bg-green-600 px-6 sm:px-8 py-20">
      <div class="max-w-3xl px-6 sm:px-8 mx-auto">
        <p class="mb-3 text-sand font-bold">KVK: 01138463</p>
        <p class="mb-10 text-sand font-bold">BTW: NL 819998539B01</p>
        <p class="mb-10 text-sand font-bold">
          Copyright ©{{ new Date().getFullYear() }}
        </p>
      </div>
    </footer>
    <footer v-if="isVastgoed" class="bg-blue-600 px-6 sm:px-8 py-20">
      <div class="max-w-3xl px-6 sm:px-8 mx-auto">
        <p class="mb-3 text-sand font-bold">KVK: 88439194</p>
        <p class="mb-10 text-sand font-bold">
          Copyright ©{{ new Date().getFullYear() }}
        </p>
      </div>
    </footer>
  </div>
</template>

<style>
.navigation {
  @apply sticky bg-sand top-0 p-6 sm:p-10 z-10 flex justify-between items-center;
}

.nav-item {
  @apply flex p-2.5;
}
</style>
